module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./ProductDetailView.js"));
	}, "SpecialProductDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=SpecialProductDetailView!./src/pages/Shop/Product/SpecialProductDetail/ProductDetailView.js
// module id = 855
// module chunks = 438